import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  trucksList: [],
  status: 'idle',
  error: null,
};

const trucksListSlice = createSlice({
  name: 'trucksList',
  initialState,
  reducers: {
    setTrucksList: (state, action) => {
      state.trucksList = action.payload;
      state.status = 'succeeded';
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.status = 'failed';
    },
    setLoading: (state) => {
      state.status = 'loading';
    },
  },
});

export const { setTrucksList, setError, setLoading } = trucksListSlice.actions;
export default trucksListSlice.reducer;
